import { API_URL }  from "../constants.js";
import axios from 'axios';
import middleware from '../util/middleware';

var request = axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type':'application/json'
    }
})

/**
 * Clase para ver el request de sitios
 */
class SitiosRequest {
    /**
     * Llamada el endpoint de django para obtener los artículos
     * en la BD
     * @param: nada
     * @return: Una lista de artículos.
     */
    static ListarSitios(filtros) {
        return middleware.hasAuth(() => request.get(`api/sitios/`, {
            params: {
                busqueda: filtros.busqueda,
                plazas_id: filtros.plazas_id,
                segmento: filtros.segmento,
                page: filtros.page,
            }
        }))
    }

    /**
     * Llamada el endpoint de django para obtener los artículos
     * en la BD
     * @param: nada
     * @return: Una lista de artículos.
     */
    static DetalleSitio(values) {
        return middleware.hasAuth(() => request.get(`api/sitios/modelo-pedido`, {
            params: {
                tipo_modelo: values.tipo_modelo,
                categoria: values.categoria,
                drives_id: values.drives_id
            }
        }))
    }

    /**
     * Llamada el endpoint de django para categorizar un artículo y guardar su
     * configuración en la BD
     * @param: value. id de categoría
     * @param: data. una lista de objetos que contiene los artículos
     * @return: Mensaje de éxito o error.
     */
    static CategorizarArticulos(value,data) {
        return middleware.hasAuth(() => request.put(`api/articulos/categorizar/${value}/`, data));
    }

    /**
     * Llamada el endpoint de django para editar variables
     * @param: value. id de categoría
     * @param: data. una lista de objetos que contiene los artículos
     * @return: Mensaje de éxito o error.
     */
    static EditarVariablesSitios(data) {
        return middleware.hasAuth(() => request.post(`api/sitios/modelo-pedido/`, data));
    }

    /**
     * Llamada el endpoint de django para editar estatus
     * @param: data. contiene la información para el endpoint
     * @return: Mensaje de éxito o error.
     */
    static EditarEstatusProductos(data) {
        return middleware.hasAuth(() => request.post(`api/sitios/estatus/articulos/`, data));
    }
}

export default SitiosRequest;